// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Textarea = createStyle({
  w: '100%',
  borderWidth: 1,
  borderColor: '$borderLight',
  borderRadius: '$sm',
  h: 100,
  backgroundColor: '$bgCard',
  _input: {
    p: '$3',
    _web: {
      outlineWidth: 0,
      outline: 'none',
    },
  },
  ':hover': {
    borderColor: '$borderMedium',
  },

  ':focus': {
    borderColor: '$borderFocus',
    ':hover': {
      borderColor: '$borderFocus',
    },
  },

  ':disabled': {
    opacity: 0.4,
    ':hover': {
      borderColor: '$borderLight',
    },
  },
  _dark: {
    borderColor: '$borderLight',
    backgroundColor: '$bgCard',
    ':hover': {
      borderColor: '$borderMedium',
    },
    ':focus': {
      borderColor: '$borderFocus',
      ':hover': {
        borderColor: '$borderFocus',
      },
    },
    ':disabled': {
      ':hover': {
        borderColor: '$borderLight',
      },
    },
  },

  variants: {
    size: {
      xl: {
        _input: {
          fontSize: '$xl',
        },
      },

      lg: {
        _input: {
          fontSize: '$lg',
        },
      },
      md: {
        _input: {
          fontSize: '$md',
        },
      },
      sm: {
        _input: {
          fontSize: '$sm',
        },
      },
      xs: {
        _input: {
          fontSize: '$xs',
        },
      },
    },
    variant: {
      default: {
        _input: {
          _web: {
            outlineWidth: '0',
            outline: 'none',
          },
        },
        ':focus': {
          borderColor: '$borderFocus',
          _web: {
            boxShadow: 'inset 0 0 0 1px $borderFocus',
          },
        },
        ':invalid': {
          borderColor: '$statusError',
          _web: {
            boxShadow: 'inset 0 0 0 1px $statusError',
          },
          ':hover': {
            borderColor: '$statusError',
          },
          ':focus': {
            ':hover': {
              borderColor: '$borderFocus',
              _web: {
                boxShadow: 'inset 0 0 0 1px $borderFocus',
              },
            },
          },
          ':disabled': {
            ':hover': {
              borderColor: '$statusError',
              _web: {
                boxShadow: 'inset 0 0 0 1px $statusError',
              },
            },
          },
        },
        _dark: {
          ':focus': {
            borderColor: '$borderFocus',
            _web: {
              boxShadow: 'inset 0 0 0 1px $borderFocus',
            },
          },
          ':invalid': {
            borderColor: '$statusError',
            _web: {
              boxShadow: 'inset 0 0 0 1px $statusError',
            },
            ':hover': {
              borderColor: '$statusError',
            },
            ':focus': {
              ':hover': {
                borderColor: '$borderFocus',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $borderFocus',
                },
              },
            },
            ':disabled': {
              ':hover': {
                borderColor: '$statusError',
                _web: {
                  boxShadow: 'inset 0 0 0 1px $statusError',
                },
              },
            },
          },
        },
      },
    },
  },

  defaultProps: {
    variant: 'default',
    size: 'sm',
  },
});
